import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { IChatMedia, IChatMessage, messageTypes } from '../../models/chat';
import {RepositoryService} from "../../../services/repository.service";
import {ITicket} from "@shared/models/ticket";
import {FirebaseService} from "@shared/firebase/firebase.service";
import {ChatService} from "@app/services/chat.service";

@Component({
  selector: 'tlm-msg',
  templateUrl: './msg.component.html',
  styleUrls: ['./msg.component.scss']
})
export class MsgComponent implements OnInit {
  @Input() msg: IChatMessage;
  @Input() ticket: ITicket;
  @Input() userId: string;
  @Output() setDelivery: EventEmitter<IChatMessage> = new EventEmitter();
  @ViewChild('player', {static: false}) player: ElementRef;
  complete: any;
  playing = false;
  time = '00:00';
  type = messageTypes;

  constructor(
    private cd: ChangeDetectorRef,
    private chatService: ChatService
  ) { }

  ngOnInit() {
    if (this.msg.fromID !== this.userId && !this.msg.deliveredAt) {
      this.setDelivery.emit(this.msg);
    }
    this.getMediaDownloadLink();
  }

  async getMediaDownloadLink() {
    switch (this.msg.type) {
      case messageTypes.IMG:
        this.msg.media.url = await this.chatService.getChatMediaDownloadLink(`ticket_${this.ticket.id}`, this.msg.media.photoID, this.msg.media.extension);
        break;
      case messageTypes.AUDIO:
        this.msg.media.url = await this.chatService.getChatMediaDownloadLink(`ticket_${this.ticket.id}`, this.msg.media.audioID, this.msg.media.extension);
        break;
      case messageTypes.DOC:
        this.msg.media.url = await this.chatService.getChatMediaDownloadLink(`ticket_${this.ticket.id}`, this.msg.media.documentID, this.msg.media.extension);
        break;
    }
  }

  geDeliveryDate(date: Map<string, string>): string {
    const index = Object.keys(date).filter((item) => item.toString() !== this.userId.toString())[0];
    return date[index];
  }

  play() {
    this.playing = true;
    this.player.nativeElement.play();
    this.player.nativeElement.addEventListener('timeupdate', () => {
      this.complete = (this.player.nativeElement.currentTime / this.player.nativeElement.duration) * 100;
      this.updateTime(this.player.nativeElement.currentTime);
      this.cd.detectChanges();
    });
  }

  stop() {
    this.player.nativeElement.pause();
    this.playing = false;
  }

  updateTime(inputSeconds: number) {
    const seconds = Math.floor(inputSeconds % 60);
    const minutes = Math.floor(inputSeconds / 60);
    const min = (minutes > 0) ? minutes.toString() : '00';
    const sec = (seconds < 10) ? `0${seconds}` : seconds.toString();
    this.time = `${min}:${sec}`;
  }

  getDocumentName(media: IChatMedia): string {
    return media.documentName + '.' + media.extension;
  }

  getDocumentSize(media: IChatMedia): number {
    return media.size;
  }

  setPosition(event) {
    this.player.nativeElement.currentTime = (event.value * this.player.nativeElement.duration) / 100;
    this.updateTime(this.player.nativeElement.currentTime);
  }
}
